import React from "react";
import DashboardLayout from "../components/DashboardLayout";

function Settings() {
  return (
    <DashboardLayout headerTitle="Settings">
      <div className="mt-[20px] text-center">Page Contents</div>
    </DashboardLayout>
  );
}

export default Settings;
